import { CalculatorOutlined, DeleteOutlined, EditOutlined, EyeOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, Modal, Popconfirm, Space, Tooltip } from "antd";
import HTTPService from "../../../utils/makerequest";
import { IPageData, IPageProps } from "../../../interfaces/page-data";
import { useEffect, useRef, useState } from "react";
import { Toast } from 'primereact/toast';
import { IDropdownItem } from "../../../AltisComponent/AltisDataGrid";
import "../CompanyManagement/CustomerManagement.css";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { ICounting } from "../../../interfaces/ICountingFilter";
import { t } from "i18next";
import i18n from "../../../i18n";
import { Moment } from "moment";
import trTR from 'antd/es/locale/tr_TR';
import enUS from 'antd/es/locale/en_US';
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";


const CountingManagement: React.FunctionComponent<IPageProps> = (props) => {
  const toast = useRef<any>(null);
  const { onSetPage } = props;
  const loader = new StateLoader();
  const [coutingData, setCoutingData] = useState<ICounting>({});
  const userInfo: IAuthentication = loader.loadAuthState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [newIsCompleted, setNewIsCompleted] = useState(false);
  const [locale, setLocale] = useState<any>(trTR);
  const [previewModalVisible, setPreviewModalVisible] = useState<number>(0);
  const [selectedCountingJob, setSelectedCountingJob] = useState<ICounting>({});




  const dataGridRef = useRef<any>(null);

  useEffect(() => {
    if (previewModalVisible != 0) {
      fetchCountingJobDetails();
    }
  }, [previewModalVisible])

  const pageData: IPageData = {
    title: t('Counting Management'),
    loaded: true
  };

  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData();
  }, [i18n.language]);

  useEffect(() => {
    if (i18n.language === 'tr') {
      setLocale(trTR);
    } else {
      setLocale(enUS);
    }
  }, [i18n.language]);

  const fetchCountingJobDetails = (e?) => {
    const filters = e?.filters;
    const body = {
      pageSize: e?.pageSize == null ? 10 : e.pageSize,
      page: e?.page == null ? 1 : e.page,
      ...filters
    };

    HTTPService.POST(`/CountingJob/getfiltersDetails?id=${previewModalVisible}&companyId=${userInfo?.companyId}`, body)
      .then((response) => {
        if (response.status === 200) {
          setSelectedCountingJob(response.data);
        } else {
          console.error("Error fetching counting job details");
        }
      })
      .catch((error) => {
        console.error("Error occurred while fetching counting job details", error);
      });
  };


  const dropdownCountStatus: IDropdownItem[] = [
    { id: 0, name: t('Expired') },
    { id: 1, name: t('In_Progress') },
    { id: 2, name: t('Not_Started') },
    { id: 3, name: t('Completed') },
  ];

  const handleCheckboxChange = (countingJobId, isCompleted) => {
    const updatedData = coutingData.data.map(item =>
      item.countingJobId === countingJobId ? { ...item, isCompleted: isCompleted } : item
    );

    const body = {
      countingJobId: countingJobId,
      isCompleted: isCompleted
    };

    HTTPService.PUT(`/CountingJob/countingIsCompleted`, body)
      .then(response => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('counting_update'),
            life: 3000
          });
          setCoutingData({ ...coutingData, data: updatedData });
        } else if (response.status === 452 || response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('update_failed'),
            life: 3000
          });
        }
      })
      .catch(error => {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t('Error occurred'),
          life: 3000
        });
      });
  };

  const countingStatus = {
    [t('Expired')]: 0,
    [t('In_Progress')]: 1,
    [t('Not_Started')]: 2,
    [t('Completed')]: 3
  };

  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [{
      title: t('Company Name'),
      key: 'companyName',
      placeHolder: t('Company Name'),
      isSorting: true,
    }] : []),
    {
      title: t('Counting Job Name'),
      key: 'countingJobName',
      placeHolder: t('Counting Job Name'),
      isSorting: true,
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: t('start_date'),
      key: 'startDate',
      placeHolder: t('start_date'),
      isSorting: true,
      align: 'center',
      headerAlign: 'center',
      dataType: 'date'
    },
    {
      title: t('finish_date'),
      key: 'finishDate',
      placeHolder: t('finish_date'),
      isSorting: true,
      align: 'center',
      headerAlign: 'center',
      dataType: 'date'
    },
    {
      title: t('Counting Status'),
      key: 'countingStatus',
      placeHolder: t('Counting Status'),
      align: 'center',
      headerAlign: 'center',
      isSorting: true,
      enumValues: countingStatus,
      render: (value) => <div>{t(value)}</div>
    },
  ];


  const previewColumns: IMUIDataGridColumns[] = [
    {
      title: t('Responsible Name'),
      key: 'responsibleName',
      align: 'center',
      headerAlign: 'center',
      placeHolder: t('Responsible Name'),
      render: (text, record) => {
        return <span>{record?.responsibleName}</span>;
      }
    },
    {
      title: t('Campus'),
      key: 'campusName',
      placeHolder: t('Campus'),
      align: 'center',
      headerAlign: 'center',
      render: (text, record) => {
        return <span>{record?.campusName}</span>;
      },
    },
    {
      title: t('Location'),
      key: 'locationName',
      placeHolder: t('Location'),
      align: 'center',
      headerAlign: 'center',
      render: (text, record) => {
        // Location adı, locationTBL içinden alınıyor
        return <span>{record?.locationName}</span>;
      },
    }
  ];


  const showModal = (countingJobId, currentStatus) => {
    setSelectedJobId(countingJobId);
    setNewIsCompleted(!currentStatus); // Checkbox'ın tersini ayarlayın
    setIsModalVisible(true); // Modalı aç
  };

  const handleOk = () => {
    handleCheckboxChange(selectedJobId, newIsCompleted);
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handlePreviewClick = (record) => {
    setPreviewModalVisible(record.countingJobId);
  }

  // isCompleted kolonunu yalnızca Admin ve AltisAdmin için ekle

  if (userInfo.role === UserRole.Admin || userInfo.role === UserRole.AltisAdmin) {
    columns.push({
      title: t('isCompleted'),
      key: 'isCompleted',
      placeHolder: t('isCompleted'),
      hideColumnMenu: true,
      align: 'center',
      render: (text, record) => {
        return (
          <Tooltip title={record.isCompleted ? t('isCompletedMessageComp') : t('isCompletedMessage')}>
            <Button
              onClick={() => showModal(record.countingJobId, record.isCompleted)}
              disabled={record.isCompleted === true}
              size="small"
            >
              {record.isCompleted ?
                <span>{record.completionDate}</span> :
                t('jobsCompleted')}
            </Button>
          </Tooltip>
        );
      },
    });
  }



  columns.push({
    title: t('Operations'),
    key: 'operations',
    hideColumnMenu: true,
    width: 300,
    placeHolder: t('Operations'),
    render: (order, record) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Space size={10}>
          <Popconfirm
            title={<div>{t('are_you_sure')} <br /></div>}
            onConfirm={() => DeleteCounting(record.countingJobId)}
            okText={t('yes')}
            cancelText={t('no')}
          >
            <Tooltip title={t('delete')}>
              <Button
                size='small'
                icon={<DeleteOutlined />}
                onClick={(e) => { e.stopPropagation(); }}
                style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
              >
              </Button>
            </Tooltip>

          </Popconfirm>


          <Tooltip title={t('update')}>
            <Button
              size='small'
              icon={<EditOutlined />}
              onClick={() => window.location.replace('/admin/counting-update/' + record.countingJobId)}
              style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
              disabled={record.isCompleted || record.countingStatus === "Expired"} // isCompleted true veya countingStatus Expired ise update butonu disable olacak 
            >
            </Button>
          </Tooltip>


          <Tooltip title={t('preview')}>
            <Button
              size='small'
              style={{ width: '60px', borderRadius: '70px' }}
              icon={<EyeOutlined />}
              onClick={() => handlePreviewClick(record)}
            >
            </Button>
          </Tooltip>


          <Tooltip title={t('details')}>
            <Button
              size='small'
              style={{ width: '60px', borderRadius: '70px' }}
              icon={<UnorderedListOutlined />}
              onClick={() => window.location.replace('/admin/details-counting/' + record.countingJobId)}
            >
            </Button>
          </Tooltip>

        </Space>
      </div>
    ),
  });

  const CountingFilter = (e?) => {
    const filters = e?.filters;

    if (filters?.startDate && Array.isArray(filters.startDate)) {
      const [startDate, endDate] = filters.startDate;
      filters.startDate_start = startDate;
      filters.startDate_Finish = endDate;
      delete filters.startDate;
    }

    if (filters?.finishDate && Array.isArray(filters.finishDate)) {
      const [startDate, endDate] = filters.finishDate;
      filters.finishDate_Start = startDate;
      filters.startDate_Finish = endDate;
      delete filters.finishDate_Finish;
    }

    if (filters?.countingStatus !== undefined) {
      if (filters.countingStatus === "" || filters.countingStatus === null) {
        delete filters.countingStatus;
      } else {
        filters.countingStatus = [Number(filters.countingStatus)];
      }
    }

    const body = {
      pageSize: e?.pageSize,
      page: e?.page,
      sortColumn: e?.sortField || '',
      sortOrder: e?.sortOrder || 'asc',
      ...filters,
    };
    HTTPService.POST(`/CountingJob/filters`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        setCoutingData(response.data);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };

  const DeleteCounting = (Id) => {
    HTTPService.DELETE(`/CountingJob/deleteCounting?Id=${Id}`).then(
      (response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(response.data),
            life: 3000
          });
          dataGridRef.current.GetAllData()
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      }
    );
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="row">
        <div className="col-md-4 mb-3">
          <Tooltip title={t('Add New Counting')}>
            <Button
              type="primary"
              shape="round"
              style={{
                height: 64,
                width: 'auto',
                backgroundColor: 'transparent',
                color: '#1890ff',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 10px',
                border: 'none',
                left: '-5px',
                transition: 'all 0.3s ease',
                display: userInfo.role === UserRole.Sayman ? 'none' : 'flex'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                e.currentTarget.style.color = '#40a9ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.color = '#1890ff';
              }}
              size="middle"
              onClick={() => window.location.replace('/admin/counting-add')}
            >
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%'
              }}>
                <CalculatorOutlined style={{ fontSize: 24, marginBottom: '4px' }} />
                <span style={{
                  fontSize: '12px',
                  textAlign: 'center',
                  width: '100%',
                  lineHeight: '1.2'
                }}>
                  {t('Add New Counting')}
                </span>
              </div>
            </Button>
          </Tooltip>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <div className='table-container'>
            <MUIDatagrid ref={dataGridRef} data={coutingData.data} total={coutingData.count} columns={columns} filterMode="server" onChange={CountingFilter} />
          </div>
        </div>
      </div>
      <ConfigProvider locale={locale}>
        <Modal
          title={<span style={{ fontWeight: 'bold' }}>{t('isCompleted')}</span>}
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <p>{t('isCompletedModalMessage')}</p>
        </Modal>
      </ConfigProvider>


      <Modal
        title={t('preview')}
        visible={previewModalVisible > 0}
        onCancel={() => setPreviewModalVisible(0)}
        footer={null}
        width={800}
      >
        {selectedCountingJob ? (
          <MUIDatagrid
            ref={dataGridRef}
            data={selectedCountingJob.data}
            columns={previewColumns}
            total={selectedCountingJob.count}
            onChange={fetchCountingJobDetails}
            filterMode="server"
          />
        ) : (
          <p>{t('Loading...')}</p>
        )}
      </Modal>



    </>


  );
};

export default CountingManagement;
